import { Box, Button, HStack, Text } from '@chakra-ui/react'
import { useExperienceManager } from '@hooks'
import { trackEvent } from '@lib/clinician-tracking'
import flagsmith from 'flagsmith'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useGrowsurfControllerGetInviteStatus } from '~/clinician-api'
import { Gift } from '../../../components/icons'
import { ReferralModalView } from '../../../components/referral-modal'
import { useReferralModalGlobal } from '../../../components/referral-modal/provider'
import { FlagsmithFeatures } from '../../../constants/flagsmith'

interface ReferralButtonProps {
  source?: string
}

export const ReferralButton: React.FC<ReferralButtonProps> = ({
  source = 'Desktop Navbar'
}) => {
  const { showReferralButton } = useExperienceManager()
  const { openReferralModal, isOpen: isReferralModalOpen } =
    useReferralModalGlobal()
  const {
    data: growsurfInviteStatusData,
    refetch: refetchGrowsurfInviteStatus
  } = useGrowsurfControllerGetInviteStatus()

  const showGrowsurfReferrals = flagsmith.hasFeature(
    FlagsmithFeatures.REFERRAL_V3
  )

  const hasUnseenUpdates = growsurfInviteStatusData?.hasUnseenUpdates ?? false

  useEffect(() => {
    if (!isReferralModalOpen) {
      refetchGrowsurfInviteStatus()
    }
  }, [isReferralModalOpen])

  if (!showReferralButton) {
    return null
  }

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    const eventName = showGrowsurfReferrals
      ? 'Referral V3 -> Clicked Refer A Friend'
      : 'Referral V2 -> Clicked Refer A Friend'
    trackEvent(eventName, {
      source
    })

    if (showGrowsurfReferrals) {
      e.preventDefault()
      openReferralModal(
        hasUnseenUpdates ? ReferralModalView.InviteStatus : undefined
      )
    }
  }

  if (showGrowsurfReferrals) {
    return (
      <Button
        variant="ghost"
        border="solid 1px #FFFFFF1A"
        color="white"
        fontWeight="normal"
        size="md"
        _focus={{ outline: 'none' }}
        onClick={handleClick}
        position="relative"
        data-click-text="Refer a friend"
      >
        <HStack spacing="2">
          <Gift fill="white" />
          <Text color="white">Refer a friend</Text>
        </HStack>
        {hasUnseenUpdates && (
          <Box
            position="absolute"
            top="0"
            right="0"
            width="8px"
            height="8px"
            borderRadius="50%"
            border="2px solid #2D54E9"
            bg="white"
            transform="translate(1px, 1px)"
            boxSizing="content-box"
          />
        )}
      </Button>
    )
  }

  return (
    <Button
      as={Link}
      to="/refer"
      variant="ghost"
      border="solid 1px #FFFFFF1A"
      color="white"
      fontWeight="normal"
      size="md"
      _focus={{ outline: 'none' }}
      onClick={handleClick}
      data-click-text="Refer a friend"
    >
      <HStack spacing="2">
        <Gift fill="white" />
        <Text color="white">Refer a friend</Text>
      </HStack>
    </Button>
  )
}

export default ReferralButton
